export const storageKeys = {
  // DISCLAIMER_ACCEPTED: 'disclaimer-accepted',
  COOKIE_ACCEPTED: 'cookie-accepted',
  NEWSLETTER_ACCEPTED: 'newsletter-accepted',
  // NEWSLETTER_SIGNUP: 'newsletter-signup',
}
